module.exports = __webpack_public_path__ + "img/vaccine_infographic.6c9ddc7c.svg";